// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"08dd8d73","203":"0255efc0","206":"79a882b0","536":"8029aabc","798":"165db3a6","914":"dc62a5c0"}[chunkId] + ".chunk.css";
};